import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import CupIcon from '../../assets/icons/cup.webp';
import DailyRaceIcon from '../../assets/icons/daily-race.svg';
import { ReactComponent as HeartIcon } from '../../assets/icons/heart.svg';
import AdaBigIcon from '../../assets/icons/icon-ada-big.svg';
import RpIcon from '../../assets/icons/rp.svg';
import { BabylonActions } from '../../babylon';
import { useStableRoutes } from '../../hooks/stable';
import { useAppSelector } from '../../store/reducers';
import ActivateHorseModal from '../Modals/ActivateHorseModal/ActivateHorseModal';
import Paragraph from '../Typography/Paragraph/Paragraph';
import AboutHorses from './AboutHorses/AboutHorses';
import HorseBox from './HorseBox/HorseBox';
import HorseMoreInfo from './HorseMoreInfo/HorseMoreInfo';
import styles from './HorsesCard.module.scss';
const HorsesCard = ({ horses, filters, onClick }) => {
    const { t } = useTranslation();
    const [limit, setLimit] = useState(10);
    const [activateModal, setActivateModal] = useState(false);
    const [asset, setAsset] = useState(null);
    const navigate = useNavigate();
    const { horseRoute } = useStableRoutes();
    const { darkMode } = useAppSelector((state) => state.settings);
    const horsesData = useMemo(() => horses
        ? horses.map((h) => {
            var _a;
            return [
                {
                    icon: CupIcon,
                    title: t('career'),
                    desc: h.volatile.career
                },
                {
                    icon: AdaBigIcon,
                    title: t('prize_money'),
                    desc: h.volatile.earnings,
                    iconComponent: true
                },
                {
                    icon: DailyRaceIcon,
                    title: t('daily_race'),
                    desc: `${(_a = h.volatile.dailyRaces) !== null && _a !== void 0 ? _a : 0}/5`
                },
                {
                    icon: RpIcon,
                    title: t('rp'),
                    desc: h.volatile.rp
                }
            ];
        })
        : [], [t, horses]);
    const horseItems = useMemo(() => {
        const getHorseIndex = (horse) => horses !== null
            ? horses.map((h) => h.static.asset.assetName).indexOf(horse.static.asset.assetName)
            : -1;
        return horses === null || horses === void 0 ? void 0 : horses.map((horse, index) => (_jsxs("div", Object.assign({ className: cn(styles.element, 'd-flex justify-content-between', darkMode && styles['isDarkMode']) }, { children: [_jsxs("div", Object.assign({ className: cn('d-flex', styles.card), onClick: () => {
                        navigate(`${horseRoute}/${horse.static.asset.assetName}`);
                        BabylonActions.UpdateSelectedHorseIndex(getHorseIndex(horse));
                    } }, { children: [_jsx(HorseBox, { data: horse }), _jsxs("div", Object.assign({ className: cn(styles.wrapper, 'd-flex justify-content-between w-100') }, { children: [horse.volatile.stats && (_jsx(AboutHorses, { className: styles.about, borderRight: true, elem: Object.assign(Object.assign({}, horse.volatile.stats), { Total: horse.volatile.totalStats }) }, horse.static.asset.assetName)), !filters && _jsx(HorseMoreInfo, { data: horsesData[index] })] }))] })), _jsxs("div", Object.assign({ className: cn(styles.race, 'd-flex flex-column justify-content-between', filters && styles['raceWithoutPadding']) }, { children: [_jsxs("div", Object.assign({ className: cn('d-flex') }, { children: [horse.volatile.isActive ? (_jsx(Paragraph, { className: styles.notActivatedRace, title: t('race').toLocaleUpperCase() })) : (_jsx(Paragraph, { className: styles.activatedRace, onClick: () => {
                                        setActivateModal(true);
                                        setAsset(horse.static.asset);
                                    }, title: t('activate').toLocaleUpperCase() })), _jsx(ArrowRight, {})] })), _jsx(HeartIcon, { className: styles.heartIcon })] }))] }), horse.static.asset.assetName)));
    }, [filters, horseRoute, horses, navigate, t, horsesData, darkMode]);
    if (!horses || horses.length === 0)
        return _jsx(_Fragment, {});
    return (horseItems === null || horseItems === void 0 ? void 0 : horseItems.length) ? (_jsxs(_Fragment, { children: [_jsx(InfiniteScroll, Object.assign({ next: () => setLimit(limit + 10), hasMore: limit < horses.length, loader: null, dataLength: limit }, { children: horseItems.slice(0, limit) })), activateModal && asset && (_jsx(ActivateHorseModal, { asset: asset, closeModal: () => setActivateModal(false) }))] })) : (_jsx("p", { children: t('no_results') }));
};
export default HorsesCard;
